export const DefaultFormValue = {
  company_name: '',
  website_address: '',
  contact_person: '',
  email: '',
  short_description: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
  teaser_headline: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
  teaser_short_description: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
}